/**
 * IosInstallNudge — Total-Redesign-Spec §1b iOS PWA path.
 *
 * iPhone Safari has no element Fullscreen API (still true 2026); the only
 * route to edge-to-edge play is the home-screen PWA (`display:
 * "fullscreen"` / standalone from manifest.webmanifest). This banner shows
 * ONCE (localStorage 'tt-ios-nudge') on the room/home screen — never
 * during play — for iOS Safari users who haven't installed yet.
 */
import { useState } from 'react';

const NUDGE_KEY = 'tt-ios-nudge';

function shouldShow(): boolean {
  try {
    if (localStorage.getItem(NUDGE_KEY)) return false;
  } catch {
    return false;
  }
  const ua = navigator.userAgent;
  const isIosDevice = /iPhone|iPad|iPod/.test(ua)
    || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  if (!isIosDevice) return false;
  // Already installed → running standalone; nothing to nudge.
  const nav = navigator as Navigator & { standalone?: boolean };
  if (nav.standalone) return false;
  if (window.matchMedia('(display-mode: standalone)').matches) return false;
  if (window.matchMedia('(display-mode: fullscreen)').matches) return false;
  return true;
}

export function IosInstallNudge() {
  const [visible, setVisible] = useState(shouldShow);
  if (!visible) return null;

  const dismiss = () => {
    try { localStorage.setItem(NUDGE_KEY, '1'); } catch { /* */ }
    setVisible(false);
  };

  return (
    <div className="ios-nudge" role="status">
      <span className="ios-nudge-icon" aria-hidden="true">
        {/* iOS share glyph: square with up-arrow */}
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 3v12" />
          <path d="M8 7l4-4 4 4" />
          <path d="M5 11v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8" />
        </svg>
      </span>
      <span className="ios-nudge-text">
        <strong>Add to Home Screen</strong> for fullscreen play — tap the Share button, then “Add to Home Screen”.
      </span>
      <button type="button" className="ios-nudge-dismiss" onClick={dismiss} aria-label="Dismiss">
        ✕
      </button>
    </div>
  );
}
